import { FileQuestion, Home, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button, Card, CardBody } from "@heroui/react";

const NotFound = () => {
    const navigate = useNavigate();

    const isAdminSite = import.meta.env.VITE_IS_ADMIN_SITE === 'true';
    const homePath = isAdminSite ? '/dashboard' : '/';

    return (
        <div className="min-h-screen bg-background flex items-center justify-center px-4">
            <Card className="max-w-md w-full shadow-none border border-border rounded">
                <CardBody className="text-center p-8">
                    <div className="flex justify-center mb-4">
                        <div className="p-3 rounded-full bg-warning/10">
                            <FileQuestion className="h-12 w-12 text-warning" />
                        </div>
                    </div>

                    <h2 className="text-xl font-semibold text-foreground mb-2">
                        Page Not Found
                    </h2>

                    <p className="text-default-500 mb-6">
                        The page you're looking for doesn't exist or has been moved.
                    </p>

                    <div className="flex flex-col gap-2">
                        <Button
                            color="primary"
                            onPress={() => navigate(homePath)}
                            startContent={<Home className="h-4 w-4" />}
                            className="rounded"
                        >
                            Go Home
                        </Button>
                        <Button
                            variant="flat"
                            onPress={() => navigate(-1)}
                            startContent={<ArrowLeft className="h-4 w-4" />}
                            className="rounded"
                        >
                            Go Back
                        </Button>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};

export default NotFound;